<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">2. Création des clefs de scellement</p>
            <p class="no-margin dark-gray text-sm">Envoyez les mails permettant à chaque membre de créer sa clef de
              scellement.</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

  </div>


  <div class="p-20 flex gap-20 align-items-center" *ngIf="!isValidated">
    <v8te-active-button [buttonText]="'Envoyer les mails de création des clefs'"
      [primaryColor]="'linear-gradient(90deg, #9332EA 0%, #CB9DF5 100%)'" [textPrimaryColor]="'#FFFFFF'"
      [iconPosition]="'left'" [border]="'none'" [icon]="'assets/mail-white.svg'" [iconAlt]="'mail icon'"
      (click)="inviteAssessorsEvent.emit()" [height]="'40px'" [minWidth]="'120px'"
      [width]="'120px'"></v8te-active-button>
    <p class="no-margin dark-blue">
      <span class="exclamation">!</span>
      Les membres recevront leur clé de scellement par email.
    </p>
  </div>

  <div *ngIf="isValidated" class="p-20">
    <div class="bg-pale-green radius-10 p-20 flex gap-10 align-items-center" style="border: solid 1px #D2F8DD;">
      <img src="assets/valid-circle-icon.svg" alt="valid icon" width="20px">
      <p class="strong-green no-margin bold">Mails envoyés</p>
    </div>
  </div>
</div>